module.exports = __webpack_public_path__ + "img/logo-new.dacb74bf.png";